export const API_ENDPOINT =
  process.env.API_ENDPOINT || 'https://172.17.17.165:8443/selfserve';
//export const API_ENDPOINT = 'http://ec2-54-158-2-144.compute-1.amazonaws.com:8080'

export const VERSION = process.env.VERSION;

export const MAGAZINE_FEED_URL =
  'https://www.thestartmagazine.com/feed/summary';

export const MEDIA_API_ENDPOINT =
  'https://contentapi.celltick.com/mediaApi/v1.0';

export const PRIVACY_POLICY_URL =
  'https://celltick-the-start-magazine.gitbook.io/the-start-magazine/privacy-policy';
export const TERM_OF_USE_URL =
  'https://celltick-the-start-magazine.gitbook.io/the-start-magazine/terms-of-use';

export const RESOURCE_URLS = {
  api: 'https://celltick-the-start-magazine.gitbook.io',
  sdk: 'https://celltick-magazine-sdk.gitbook.io'
};



// WEBPACK FOOTER //
// ./src/app/config.js